module.exports = __webpack_public_path__ + "img/8O.86a8613a.png";